import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Page from 'containers/ResourcePage/Page';
import { Redirect } from 'react-router-dom';
import PageLoader from 'components/PageLoading';

const ResourcePage = ({
  loading,
  isData,
  resourceId,
  groupId,
  resourcesLoadData,
  currentResource,
}) => {
  useEffect(() => {
    if (!loading && isData && currentResource !== resourceId) {
      resourcesLoadData({ resourceId });
    }
  });

  if (!isData) {
    return <Redirect to="/404" />;
  }

  if (loading || currentResource !== resourceId) {
    return <PageLoader />;
  }

  return <Page resourceId={resourceId} groupId={groupId} />;
};

ResourcePage.propTypes = {
  isData: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  currentResource: PropTypes.string,
  resourcesLoadData: PropTypes.func.isRequired,
  resourceId: PropTypes.string.isRequired,
  groupId: PropTypes.string.isRequired,
};

ResourcePage.defaultProps = {
  currentResource: null,
};

export default ResourcePage;
